import Api from "../../api.js";

export const update = async (url, data) => {
    return (await Api.put(url, data))?.data
}
